import { render } from "./footer.vue?vue&type=template&id=aa9ad1aa&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=aa9ad1aa&scoped=true&lang=css"

import exportComponent from "D:\\code2\\demo2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9ad1aa"]])

export default __exports__